module.exports = __webpack_public_path__ + "static/media/any_element.34db005c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/elements/any_element.svg
// module id = 75
// module chunks = 0